export const allMethods = ['get', 'put', 'post', 'delete', 'options', 'head', 'patch', 'trace'];
